export default  {
    component: 'relay_param',
    name: 'relay_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text'
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text'
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text'
          }

  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }
